SET_PAYMENT_TEST_CODE